import { Component, Input } from "@angular/core"
import { CollectionNode } from "../../../models/collectionNode.model"
import { CollectionService } from "../../../services/collection.service"
import { CollectionResourceRequestParams } from "../../../models/collectionResourceRequestParams.model"

@Component({
    selector: "app-load-more-resources",
    templateUrl: "./load-more-resources.component.html",
    styleUrls: ["./load-more-resources.component.scss"],
    standalone: false,
})
export class LoadMoreResourcesComponent {
    @Input() collection: CollectionNode
    @Input() paginated: boolean = true
    currentIndex: number
    private paginationSize: number = 6

    constructor(private collectionService: CollectionService) {
        this.currentIndex = this.paginationSize
    }

    seeMore() {
        this.currentIndex += this.paginationSize
        let page = this.collectionService.getPage(
            this.currentIndex,
            this.collectionService.collectionResourceCount
        )
        if (this.collection.resources[page] && !this.collection.resources[page].length) {
            let params = new CollectionResourceRequestParams(
                this.currentIndex,
                this.collectionService.collectionResourceCount,
                this.collection.id
            )
            this.collectionService.loadResourceFor(this.collection, params)
        }
    }

    seeLess() {
        this.currentIndex = this.paginationSize
    }

    canSeeMore() {
        return (
            !!this.collection.resources.length && this.currentIndex < this.collection.totalResources
        )
    }

    canSeeLess() {
        return this.currentIndex > this.paginationSize
    }
}
